module.exports = __webpack_public_path__ + "img/arrow-left.f5ee0a13.svg";